import { useCallback, useState } from 'react';
import UserFormComponent from '../components/user-form.component';
import { UserCreate, UserUpdate } from '../types/user.types';
import { useUserCreate } from '../hooks/use-user.hook';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  extractCreateError,
  extractValidationError,
} from '../../../../../services/extract-api-error.service';
import HeaderRow from '../../../../common/HeaderRow';
import { ValidationError } from '../../../../../types/api-response.types';
import { useTranslation } from 'react-i18next';
import { WithPermissionCheck } from '../../../../auth/WithPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const UserCreateContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>([]);

  const { mutateAsync: createUser, isPending } = useUserCreate();

  const onFormSubmit = useCallback(
    async (data: UserCreate | UserUpdate, resetForm: () => void) => {
      // Reset validation errors on new submission
      setValidationErrors([]);

      // For create operations, we know we'll have all required fields
      const createData = data as UserCreate;
      try {
        const response = await createUser(createData);
        message.success(t('crud.create.success', { entity: t('users.title') }));
        resetForm();
        navigate(`/dashboard/user/${response.data.id}`);
      } catch (error: any) {
        const errorFields = extractValidationError(error);
        setValidationErrors(errorFields);
        const errorMessage = extractCreateError(
          error,
          t('crud.create.error', { entity: t('users.title') })
        );
        message.error(errorMessage);
      }
    },
    [createUser, navigate, t]
  );

  return (
    <>
      <PageTitle title={t('crud.create.title', { entity: t('users.title') })} />
      <HeaderRow
        title={t('crud.create.title', { entity: t('users.title') })}
        showBackButton={true}
      />
      <div className="row mt-3">
        <UserFormComponent
          onFormSubmit={onFormSubmit}
          isLoading={isPending}
          columns={3}
          validationErrors={validationErrors}
        />
      </div>
    </>
  );
};

export default WithPermissionCheck(UserCreateContainer, 'user.create');
